@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.wrapper {
  display: flex;
  align-items: center;
}

.wrapper.shrink {
  overflow: hidden;
  .badgeKey {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .badge-key--partition-key {
    flex-shrink: 3;
  }
  .badge-key--not-null {
    flex-shrink: 2;
  }
}

.badgeKey {
  border: solid  hevo-toolkit-variables.$border-width  hevo-toolkit-variables.$divider-color;
  border-radius:  hevo-toolkit-variables.$border-radius-default;
  padding:  hevo-toolkit-variables.$spacer * 0.125  hevo-toolkit-variables.$spacer * 0.25;
  background:  hevo-toolkit-variables.$surface-bg-overlay;
  flex-shrink: 0;
}

$color-pk: var(--key-badge-pk);
$color-sk: var(--key-badge-sk);
$color-dk: var(--key-badge-dk);
$color-ck: var(--key-badge-ck);
$color-partition-key: var(--key-badge-partition-key);
$color-not-null: var(--key-badge-not-null);

.badge-key--pk {
  color: $color-pk;
}

.badge-Key--sk {
  color: $color-sk;
}

.badge-key--dk {
  color: $color-dk;
}

.badge-key--ck {
  color: $color-ck;
}

.badge-key--partition-key {
  color: $color-partition-key;
}

.badge-key--not-null {
  color: $color-not-null;
  text-transform: capitalize;
}
